import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import { config } from 'config';
import ReadNext from '../ReadNext';
import './style.css';
import '../../static/css/highlight.css';
import profilePic from '../../pages/photo_optimized.jpg';
import ReactDisqusThread from 'react-disqus-thread';
import Helmet from 'react-helmet';

class SitePost extends React.Component {
  render() {
    const { route } = this.props;
    const post = route.page.data;

    const helmet = (
      <Helmet title={post.title} meta={[
          {"name": "description", "content": post.description},
          {"property": "twitter:title", "content": post.title},
          {"property": "twitter:description", "content": post.description},

          {"property": "twitter:card", "content": "summary"},
          {"property": "twitter:creator", "content": config.twitterUser},
          {"property": "twitter:url", "content": config.canonicalUrl},
          {"property": "twitter:image", "content": prefixLink(profilePic)},
          {"property": "twitter:image:alt", "content": "My profile image"},
          {"property": "og:image", "content": prefixLink(profilePic)}
      ]}/>
    );
    const home = (
      <div>
        <Link className="gohome" to={prefixLink('/')}>All Articles</Link>
      </div>
      );
    const handleNewComment = () => {
      //console.log('new comment');
    }

    return (
      <div>
        {helmet}
        {home}
        <div className="blog-single">
          <div className="text">
            <h1>{post.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: post.body }} />
            <div className="date-published">
              <em>Published {moment(post.date).format('D MMM YYYY')}</em>
            </div>
          </div>
          <div className="footer">
            <ReadNext post={post} {...this.props} />
            {process.env.NODE_ENV === "production" ?
            <ReactDisqusThread
              shortname={config.disqusShortName}
              identifier={post.id}
              title={post.title}
              url={config.canonicalUrl + this.props.location.pathname}
              onNewComment={handleNewComment}/> : <b><i style={{color: '#FF0000'}} className="fa fa-exclamation-circle" aria-hidden="true"></i> No Disqus in devel</b>}
            <hr />
            <p>
              {config.siteDescr}
            </p>
          </div>
        </div>
      </div>
      );
  }
}

SitePost.propTypes = {
  route: React.PropTypes.object.isRequired,
};

export default SitePost;



// WEBPACK FOOTER //
// ../components/SitePost/index.jsx